import { render } from "./ClientSettings.vue?vue&type=template&id=141d4c8e"
import script from "./ClientSettings.vue?vue&type=script&lang=js"
export * from "./ClientSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__